import { CartPaymentCardType } from 'generated/rbi-graphql';

export const isApplePay = (accountIdentifier: string | null) =>
  accountIdentifier === CartPaymentCardType.APPLE_PAY;

export const isGooglePay = (accountIdentifier: string | null) =>
  accountIdentifier === CartPaymentCardType.GOOGLE_PAY;

export const isPayPal = (accountIdentifier: string | null) =>
  accountIdentifier === CartPaymentCardType.PAYPAL;

export const isCash = (accountIdentifier: string | null) =>
  accountIdentifier === CartPaymentCardType.CASH;
